import { useState, useEffect } from "react";
import {message} from "antd";
import CircularProgress from "../CircularProgress";
import FilteredTable from "../table/filteredTable";
import Widget from "../Widget";
import { pricify } from "../../util/textFormater";
import { getRequestsDetails } from "../../API/RequestHistory";
import Classes from "./index.module.css";

export default function FactorDetail({ shomInvoice }) {
  const [products, setproducts] = useState([]);
  const [loading,setLoading] =useState(true);
  useEffect(() => {
    getRequestsDetails({ shomDetails: shomInvoice }).then((i) => {
      if(i.success){
        setproducts(i.data);
      }else{
        message.error("مشکلی هنگام دریافت اطلاعات رخ داد");
      }
    }).finally(()=>{
      setLoading(false);
    }).catch((e)=>{
      
      message.error("مشکلی هنگام انجام عملیات رخ داد");
    });
  }, []);
  const invoiceColumn = [
    {
      title: "قیمت",
      dataIndex: "price",
      key: "price",
      render: (text, record) => (
        <span>{pricify((record.count * record.fee).toString())}</span>
      ),
      search: true,
    },
    {
      title: "تعداد",
      dataIndex: "count",
      key: "count",
      search: true,
    },
    {
      title: "فی",
      dataIndex: "fee",
      key: "fee",
      search: true,
      render: (text, record) => <span>{pricify(record.fee.toString())}</span>,
    },
     {
      title: "شرح کالا",
      dataIndex: "nameItem",
      key: "nameItem",
      search: true,
    },
  ];
  return (
    <>
      {loading && <CircularProgress/>}
      {!loading && [<FilteredTable data={products} headers={invoiceColumn} />,

<Widget>
  <div className={Classes.finalPriceTitle}>:جمع نهایی</div>
  <div className={Classes.finalPrice}>
    {pricify(
      products
        .map((i) => {
          return i.count * i.fee;
        })
        .reduce((a, b) => a + b, 0)
        .toString()
    )}
  </div>
</Widget>]}
    </>
  );
}
